import { combineReducers } from "redux";
import constants from "modules/wizard/constants";
import createApiReducer from "reducers/createReducers";

const reducers = combineReducers({
  createAdsResult: createApiReducer(constants.CREATE_ADS, {}),
});

export default reducers;
